import React, { createContext, useContext, useState, useCallback, useEffect, useMemo, } from 'react';
import { ConfirmationModal } from '../ConfirmationModal/ConfirmationModal';
import { localise } from '../../../services/lang/lang';
const UnsavedChangesContext = createContext(undefined);
export const UnsavedChangesProvider = ({ children }) => {
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [isDialogOpen, setDialogOpen] = useState(false);
    const [pendingClose, setPendingClose] = useState(undefined);
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (hasUnsavedChanges) {
                event.preventDefault();
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [hasUnsavedChanges]);
    const attemptNavigate = useCallback((onConfirm) => {
        if (!hasUnsavedChanges) {
            onConfirm();
            return;
        }
        setPendingClose(() => onConfirm);
        setDialogOpen(true);
    }, [hasUnsavedChanges]);
    const contextValue = useMemo(() => ({ hasUnsavedChanges, setHasUnsavedChanges, attemptNavigate }), [hasUnsavedChanges, attemptNavigate]);
    return (React.createElement(UnsavedChangesContext.Provider, { value: contextValue },
        children,
        React.createElement(ConfirmationModal, { isOpen: isDialogOpen, onClose: () => setDialogOpen(false), onConfirm: () => {
                setDialogOpen(false);
                pendingClose?.();
            }, title: localise('UNSAVED_CHANGES') }, localise('UNSAVED_CHANGES_MESSAGE'))));
};
export const useUnsavedChanges = () => {
    const context = useContext(UnsavedChangesContext);
    if (!context) {
        throw new Error('useUnsavedChanges must be used within an UnsavedChangesProvider');
    }
    return context;
};
